import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Planbook } from "@shared/models/planbook"
import type Router from "cc-frontend/router"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import UnsplashUpload from "react-app/components/planner/modals/UnsplashUpload"
import styles from "./unsplash-modal.module.css"

export interface UnsplashModalSignature {
  Args: {
    closeModal: () => void
    order: number
    model: {
      planbook: Planbook
      selectBackground: (url: string, type: string) => void
    }
  }
}

export default class UnsplashModal extends Component<UnsplashModalSignature> {
  readonly styles = styles

  @service declare router: Router
  @service declare rpc: Rpc
  @service("ember-store") declare store: EmberStore

  UnsplashUpload = UnsplashUpload

  @action
  onUnsplashPhotoSelected(url: string) {
    this.args.model.selectBackground(url, "unsplash")

    this.args.closeModal()
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Planbook::UnsplashModal": typeof UnsplashModal
  }
}
